import React from 'react';

interface QuoteGuaranteeHeaderProps {
  title: string;
}

const QuoteGuaranteeHeader: React.FC<QuoteGuaranteeHeaderProps> = ({ title }) => (
  <div className="shadow-sm p-4 bg-white rounded mb-4">
    <h3 className="mb-3">{title}</h3>
    <p>
      Para começar, tenha em mãos o documento que comprove a solicitação da garantia (Contrato,
      edital, termo de referência ou e-mail do órgão). Em caso de dúvidas,{' '}
      <a href="/conlicitaseg/contato" target="_blank" rel="noopener noreferrer">
        fale com nossos especialistas
      </a>
      .
    </p>
    <p className="mb-0">
      Solicitações de endosso (prorrogações, renovações, inclusão de coberturas ou outras
      alterações) devem ser tratadas diretamente com nossos especialistas.
    </p>
  </div>
);

export default QuoteGuaranteeHeader;
